module.exports = __webpack_public_path__ + "static/media/compress-alt-left.ed78bdae.svg";